import styled from "styled-components/macro";

export const Container = styled.div`
  // background-color: var(--menu-color-primary-cta-overlay);
  background-color: var(--menu-color);
  border-radius: 20px;
  box-shadow: var(--drop-shadow-15-25);
  margin-top: 20px;
  margin-bottom: 10px;
  min-height: 264px;

  padding: 18px;
  font-weight: 500;
  color: var(--grey-0);

  .no-thanks {
    .text-button-inner {
      color: var(--grey-1);
    }
  }

  .character-offer-image {
    width: 355px;
    float: right;
    background-color: #fff;
    border: 1px solid var(--grey-3);
    border-radius: 10px;
    padding: 20px;
    margin-left: 20px;
    margin-right: 0px;
  }

  .header-right {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
  .upgrade-button {
    margin-top: 0 !important;
    border-radius: 10px !important;
  }
  .explainer {
    margin-top: 1em;
  }
  .faq-button {
    background: none !important;
    color: var(--grey-0) !important;
    text-decoration: underline;
    border: none;
    padding: 0 !important;
    margin: 0 !important;
    margin-top: 1em !important;
  }

  .character-offer-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 1em;
    h1 {
      font-size: 20px;
      font-weight: 500;
      color: var(--grey-0);
    }
  }

  .upgrade-container {
    .primary {
      display: flex;
      flex-direction: row;
      gap: 8px;
      padding: 7px 12px 7px 7px !important;
    }
    position: relative;
    display: flex;
    flex-direction: column;
    .svg-container {
      float: right;
    }
    .free-badge {
      position: absolute;
      right: 25px;
      top: -15px;
    }
  }

  .inline-svg {
    position: relative;
    top: 5px;
    path {
      fill: var(--grey-0);
    }
  }

  h2 {
    margin-top: 2em;
    margin-bottom: 12px !important;
    font-weight: 600;
  }

  h3 {
    margin-bottom: 0em;
    margin-top: 1em;
  }

  .q-or-a {
    font-weight: 600;
    color: var(--grey-1);
    padding-right: 10px;
    padding-top: 10px;
  }

  strong {
    font-weight: 600;
  }

  .beginning-of-question {
    padding-top: 25px;
  }
  table {
    line-height: 1.5em;
    /* width: 100%; */
  }
`;
